import React from 'react'
import AliceCarousel from 'react-alice-carousel'
import { Row, Col } from 'react-bootstrap'
import size from 'lodash/size';
import transform from 'lodash/transform';

import 'react-alice-carousel/lib/alice-carousel.css'
import './reservation.css'
import LoaderImg from '../../images/ajax_loader.gif'

class ReservationScroll extends React.Component {
    constructor(props) {
        super(props)
        this.responsive = {
            1024: { items: 7 },
            767: { items: 5 },
            570: { items: 4 },
            374: { items: 3 },
            0: { items: 2 },
        }

        this.state = { scrollIndex: 0, currentIndex: 0, currentItem: 0 }
        
    }
    slidePrev=()=>this.Carousel.slidePrev()
    slideNext=()=>this.Carousel.slideNext()
    carouselRef=(el)=>this.Carousel = el
        
    onSlideChanged = (e) => {
        let leftArrow = document.querySelector('.show button[data-test-id="time-slot-left"]');
        let rightArrow = document.querySelector('.show button[data-test-id="time-slot-right"]');
        let currentItem = e.item;
        let itemsIn = e.itemsInSlide
        let totalItems = size(this.props.timeSlots);
        if (leftArrow) {
            leftArrow.style.visibility = (!currentItem) ? "hidden" : "visible";
        }

        if (rightArrow) {
            rightArrow.style.visibility = ((currentItem + itemsIn) + 2 >= totalItems) ? "hidden" : "visible";
        }
        this.setState({ scrollIndex: e.item })
    }
    render() {
        let { timeSlots = [], displayNavButtons, dayConflictsMsg } = this.props
        //const { currentIndex, scrollIndex } = this.state

        return (
            <>
                {dayConflictsMsg && (<div className='container text-center orange  bottom-spacing-10 spa-box conflict-box'>
                    <span className='day-conf-msg'>{dayConflictsMsg}</span>
                </div>)}
                {timeSlots && size(timeSlots) <= 9 && displayNavButtons ? (
                    <fieldset>
                        <legend className="visuallyhidden">Choose a Time</legend>
                        <Row className="horizontal-scroll container">
                            <Col md={12}>
                                <div className="time-scroll time-no-arrow  row">
                                    {getItems(timeSlots, this.props)}
                                </div>
                            </Col>
                        </Row>
                    </fieldset>
                ) : (
                        <fieldset>
                            <legend className="visuallyhidden">Choose a Time</legend>
                            <Row className="horizontal-scroll container">
                                {displayNavButtons ? (
                                    <Col md={1}>
                                        <button
                                            style={{ visibility: 'hidden' }}
                                            onClick={this.slidePrev}
                                            className="scroll-arrow-container left-arrow  d-none d-md-block"
                                            data-test-id="time-slot-left"
                                            aria-label="Scroll left to view additional times"
                                        >
                                            <svg

                                                focusable="false"
                                                className="svg-icon svg-icon-chevron"
                                            >
                                                <use xlinkHref="#icon-chevron"></use>
                                            </svg>
                                        </button>
                                    </Col>
                                ) : null}
                                <Col md={10}>
                                    <div className="scroll-container">
                                        <div className="time-scroll" data-test-id="scroll-container">
                                            <AliceCarousel
                                                mouseDragEnabled
                                                responsive={this.responsive}
                                                buttonsDisabled={true}
                                                infinite={false}
                                                dotsDisabled={true}
                                                slideToIndex={this.state.scrollIndex}
                                                startIndex={this.state.scrollIndex}
                                                onSlideChanged={this.onSlideChanged}
                                                items={getItems(timeSlots, this.props)}
                                                ref={this.carouselRef}
                                            ></AliceCarousel>
                                        </div>
                                    </div>
                                </Col>
                                {displayNavButtons ? (
                                    <Col md={1} className='arrow-scroll-container'>
                                        <button
                                            className="scroll-arrow-container  d-none d-md-block"
                                            data-test-id="time-slot-right"
                                            onClick={this.slideNext}
                                            aria-label="Scroll right to view additional times"
                                        >
                                            <svg
                                                role="img"
                                                focusable="false"
                                                className="svg-icon svg-icon-chevron"
                                            >
                                                <use xlinkHref="#icon-chevron"></use>
                                            </svg>
                                        </button>
                                    </Col>
                                ) : null}
                            </Row>
                        </fieldset>
                    )}
            </>
        )
    }
}

const onReserveService = (props, time, inCartClass) => props.onReserveService(time, inCartClass)

const getItems = (timeSlots, props) => {
    let { cart = [], ShipboardCurrencyCode } = props

    let scrollItems = transform(
        timeSlots,
        function (result, time) {
            let inCartClass = ''
            let { selectedReservation = {} } = props
            if (cart && cart.length > 0) {
                inCartClass = cart.find((cartItem) => cartItem.resHoldId === time.resHoldId)
                    ? 'in-cart-item'
                    : ''
            }
            if (time.resHoldId)
                result.push(
                    <button
                        data-test-id="reservation-time-slots"
                        className={`carousel-time-card oo ${inCartClass}  filter-benefits-button datecard-hover `}
                        onClick={onReserveService.bind(this, props, time, inCartClass)}
                    >
                        <p
                            className={`Reserve-card-date ${inCartClass} reserve-time-slot`}
                            data-test-id="reserve-card-time"
                        >
                            {time.formattedTime}
                        </p>
                        {(props.isReserveLoading &&
                            selectedReservation.resHoldId === time.resHoldId) ? (
                                <span className="reserve-loading">
                                    <img
                                        alt="Loader-spinner"
                                        width="25px"
                                        height="25px"
                                        src={LoaderImg}
                                    />

                                </span>

                            ) : (
                                <>
                                    <p
                                        className="Reserve-card-price font-size-p2 gotham-xn-medium no-pad-margin margin-top-13"
                                        data-test-id="reserve-price"
                                    >
                                        {` `}
                                        {(inCartClass !== 'in-cart-item') &&
                                            <span className="font-size-p2 gotham-xn-medium no-pad-margin">
                                                <sup className="font-size-14">{`${ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'} `}{' '}</sup>
                                            </span>}
                                        <span className="font-size-p10 gotham-xn-medium">{` ${inCartClass === 'in-cart-item' ? 'In Cart' : time.treatmentPrice}`}</span>
                                    </p>
                                </>
                            )}
                        {props.isReserveLoading &&
                            selectedReservation.resHoldId === time.resHoldId ? null :
                            <p
                                className={`Reserve-card-text ${inCartClass}  font-size-p2 gotham-xn-book no-pad-margin no-pad-margin margin-top-min-10`}
                                data-test-id="remove-reserve-label"
                            >
                                {inCartClass ? 'Remove' : 'Reserve'}
                            </p>
                        }
                    </button>
                )
            else
                return false
            return true
        },
        []
    )
    return scrollItems
}

export default ReservationScroll
